import BaseComponent from '@js/BaseComponent'
import { hasMotion } from '@js/mediaQueries'

/**
 * Handles removal and focus states for CensoredMedia components
 *
 * @extends BaseComponent
 */
class CensoredMedia extends BaseComponent {
    constructor(element) {
        super(element)

        this.button = this.element.querySelector('button')
        this.container = this.element.querySelector('.flex')
        this.hiddenElement = this.element.lastElementChild
        this.maximize = this.element.parentElement.querySelector('.maximize')

        this.button.addEventListener('click', this.reveal)
        this.hiddenElement.ariaHidden = true
        this.maximize?.setAttribute('tabindex', -1)

        Array('focus', 'mouseenter').forEach(event => {
            this.button.addEventListener(event, this.showFocus)
        })

        Array('blur', 'mouseleave').forEach(event => {
            this.button.addEventListener(event, this.hideFocus)
        })
    }

    /**
     * Removes the filter and deletes the markup used to create it
     */
    reveal = () => {
        this.element.dataset.inactive = true
        this.hideFocus()

        Array('focus', 'mouseenter').forEach(event => {
            this.button.removeEventListener(event, this.showFocus)
        })

        Array('blur', 'mouseleave').forEach(event => {
            this.button.removeEventListener(event, this.hideFocus)
        })

        if (!hasMotion()) {
            this.removeElement()
        } else {
            this.container.addEventListener('transitionend', event => {
                if (event.target === this.container) {
                    this.removeElement()
                }
            })
        }
    }

    /**
     * Deletes the filter markup and sets focus
     */
    removeElement = () => {
        this.element.parentElement?.replaceChild(
            this.hiddenElement,
            this.element
        )
        this.hiddenElement.removeAttribute('aria-hidden')
        this.maximize?.removeAttribute('tabindex')
        this.hiddenElement.focus()
    }

    /**
     * Shows the focus ring
     */
    showFocus = () => {
        this.element.dataset.focusRing = 'active'
    }

    /**
     * Hides the focus ring
     */
    hideFocus = () => {
        this.element.dataset.focusRing = undefined
    }
}

CensoredMedia.create('.censored')
